import React, { useEffect, useState } from "react";
// images
import TotalActiveTime from "../../Assets/images/dashboard/TotalActiveTime.svg";
import TotalBreakTime from "../../Assets/images/dashboard/TotalBreakTime.svg";
import AgentNotReady from "../../Assets/images/dashboard/agentnotready.svg";
import LoggedInAgents from "../../Assets/images/dashboard/LoggedInAgents.svg";
import SLADigital from "../../Assets/images/dashboard/SLADigital.svg";
import queueCount from "../../Assets/images/dashboard/queueCount.svg";
import LongestWait from "../../Assets/images/dashboard/LongestWait.svg";
import AgentActive from "../../Assets/images/dashboard/AgentActiveDash.svg";
import Abandoned from "../../Assets/images/dashboard/Abandoned.svg";
import agentOffline from "../../Assets/images/dashboard/agentOffline.svg";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";
import CallMadeIcon from "@mui/icons-material/CallMade";
// mui
import {
  Typography,
  Box,
  Pagination,
  Stack,
  Chip,
  Grid,
  Paper,
  TableContainer,
  TableBody,
  Table,
  TableRow,
  TableHead,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import Popover from "@mui/material/Popover";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { useNavigate, useOutletContext } from "react-router-dom";
import Badge from "@mui/material/Badge";
import moment from "moment";
// icons
import { FaClock, FaBusinessTime } from "react-icons/fa";
import QuickreplyIcon from "@mui/icons-material/Quickreply";
import ForumIcon from "@mui/icons-material/Forum";
import PermPhoneMsgIcon from "@mui/icons-material/PermPhoneMsg";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import OutboundIcon from "@mui/icons-material/Outbound";
import GroupIcon from "@mui/icons-material/Group";
import { TiWarningOutline } from "react-icons/ti";
import {
  ArrowsIn,
  ArrowsOut,
  ChatsCircle,
  Envelope,
  FacebookLogo,
  Phone,
  Robot,
  TwitterLogo,
  VideoCamera,
  WhatsappLogo,
} from "@phosphor-icons/react";
// other
import {
  AvcUrl,
  BaseUrl,
  PowerBiurl,
  VoiceDomainName,
  VoiceDomainNamePure,
} from "../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import { endInteraction, setsidebarVal } from "../../Redux/Actions/actions";
// component import
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { Eye, SignOut } from "@phosphor-icons/react";
import Tooltip from "@mui/material/Tooltip";
import { toaststyle } from "../../Utils/toaststyle";
import { Spinner } from "react-bootstrap";

const StyledPaper = styled(Paper)(({ theme }) => ({
  height: "100%",
  padding: "10px 10px 50px 10px",
  background: "none",
  boxShadow: "none",
  borderRadius: "none",
}));

const StyledPaper2 = styled(Paper)(({ theme }) => ({
  height: "100%",
  overflowY: "scroll",
  padding: "10px 10px 20px 10px",
  background: "none",
  boxShadow: "none",
  borderRadius: "none",
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "",
    color: theme.palette.common.black,
    padding: "8px",
    fontWeight: 600,
    borderBottom: "none",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));
const StyledTableCell2 = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.root}`]: {
    backgroundColor: "#FFFF",
    color: theme.palette.common.black,
    padding: "20px 8px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));

const StyledTableCell3 = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.root}`]: {
    backgroundColor: "#FFFF",
    color: theme.palette.common.black,
    padding: "5px 8px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));

import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

const mapStateToProps = (state) => {
  return {
    chatid: state.data.chatid,
    chat: state.data.chat,
    agentStatusrefreash: state.data.agentStatusrefreash,
    showingStatus: state.contactListData.showingStatus,
    voicePlatForm: state.voice.voicePlatForm,
  };
};

const calculateDuration = (value) => {
  const lastActiveTime = moment(value);
  const currentTime = moment();
  const duration = moment.duration(currentTime.diff(lastActiveTime));
  const formattedDuration = moment
    .utc(duration.asMilliseconds())
    .format("HH:mm:ss");

  return formattedDuration;
};

const Dashboard = (props) => {
  const [callObj2, callmap, playMsgTone, stopwatch1, stopwatch2, WebSocket] =
    useOutletContext();
  const navigate = useNavigate();
  const LoggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
  let permission = JSON.parse(localStorage.getItem("permission"));

  const [dashboardcount, setDashboardcount] = useState([]);
  const [teamactivitydashboardcount, setTeamactivitydashboardcount] = useState(
    []
  );
  const [loader, setloader] = useState(false);
  const [dashboardcountagent, setDashboardcountagent] = useState([]);
  const [OngoingInteractionList, setOngoingInteractionList] = useState([]);
  const [TotalqueueCount, setTotalqueueCount] = useState("");
  const [OngoingInteraction, setOngoingInteraction] = useState(false);
  const [pagination, setPagination] = useState(0);
  const [page, setpage] = useState(1);
  const [userstatus, setUserstatus] = useState([]);
  const [showAllUserList, setshowAllUserList] = useState(true);
  const [anchorEl, setAnchorEl] = useState({});
  const openPopover = (index) => Boolean(anchorEl[index]);
  const [open2, setOpen2] = useState(false);

  const id = (index) =>
    openPopover(index) ? `simple-popover-${index}` : undefined;

  const handleClick2 = () => {
    setOpen2(!open2);
  };

  const handleClick = (event, index) => {
    setAnchorEl((prev) => ({ ...prev, [index]: event.currentTarget }));
    setOpen2(false);
  };

  const handleClose = (index) => {
    setAnchorEl((prev) => ({ ...prev, [index]: null }));
  };

  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];

  const convertSecondsToTime = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toFixed(2).toString().padStart(5, "0")}`;
  };

  const SupervisorObserver = async (el) => {
    let AvcUrl = localStorage.getItem("AvcUrl");
    switch (el.channel) {
      case "webchat":
      case "from_whatsapp":
      case "from_facebook":
      case "from_purple":
      case "from_google":
        let dataToPass = {
          oldAgentId: el.agent,
          sessionId: el.chat_session_id,
          agentId: JSON.parse(localStorage.getItem("tokenAgent")).agent_id,
        };

        await axios
          .post(BaseUrl + "/users/observeAgent", dataToPass, {
            headers: {
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
              Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
          })
          .then((res) => {
            if (res.data.status) {
              props.setsidebarVal("Chat");
              navigate("/main/Chat");
              toast.success("Interaction Observed Successfully", toaststyle);
            } else {
              toast.warn(res.data.message, toaststyle);
            }
          })
          .catch((err) => {
            console.log("SupervisorObserver", err);
          });

        break;
      case "voice":
        if (props.voicePlatForm == "ACCS" || props.voicePlatForm == "AACC") {
          await axios
            .post(
              AvcUrl +
              `/voice/terminal/${localStorage.getItem(
                "agentLoginTerminalId"
              )}/observe/sip:${localStorage.getItem(
                "agentLoginTerminalId"
              )}@${VoiceDomainName}/${el.voice_contactId}`,
              {},
              {
                headers: {
                  ssoToken: localStorage.getItem("ssoToken"),
                },
              }
            )
            .then((res) => {
              console.log("voice_observe", res);
              if (res.data.statusCode == 200) {
                localStorage.setItem("Bargin", "true");
              } else {
                toast.warn(res.data.message, toaststyle);
              }
            })
            .catch((err) => { });
        } else if (props.voicePlatForm == "AES") {
          const extensionNum = JSON.parse(
            localStorage.getItem("AvayaUsername")
          );
          var RegDetails = {
            Event: "SOActivate",
            ObserverDeviceId: extensionNum,
            ObserveeDeviceId: el.unique_id.phonenumber,
            SOActivateConnState: 12,
            ObserveeLocationVDN: "listen only mode",
          };
          localStorage.setItem("observeAgentList", JSON.stringify(el));
          localStorage.setItem("dailedNumber", el.unique_id.phonenumber);
          localStorage.setItem("Bargin", "true");
          WebSocket.send(JSON.stringify(RegDetails));
        }
        break;
      default:
        return;
    }
  };
  const outboundOberver = async (el) => {
    const getObserverAgentNumber = teamactivitydashboardcount?.find(
      (item) => item.agent_id.id === el.agent)
    if (!getObserverAgentNumber) {
      toast.warn("Their is no extension number", toaststyle);
      return;
    }
    let number = `429888${getObserverAgentNumber.agent_id.CTIagentLoginTerminalId}`;
    let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
    let avcurlid = localStorage.getItem("AvcUrl");

    if (props.voicePlatForm == "ACCS" || props.voicePlatForm == "AACC") {
      axios
        .post(
          `${avcurlid}/voice/terminal/${agentLoginTerminalId}/createContact/sip:${agentLoginTerminalId}@${VoiceDomainName}/sip:${number}@${VoiceDomainName}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          }
        )
        .then(() => { })
        .catch((err) => {
          console.log("outboundOberver", err);
        });
    }
  };


  const SupervisorTeamActivityList = async () => {
    await axios
      .post(
        BaseUrl + "/dashboard/chatCount",
        {
          from_date: defaultValue,
          to_date: defaultValue,
          offset: 0,
          limit: 10000,
          agent_id: LoggedInAgent.agent_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          setTeamactivitydashboardcount(res.data.Data);
        } else {
          setTeamactivitydashboardcount([]);
        }
      })
      .catch((err) => {
        console.log("SupervisorTeamActivityList", err);
      });
  };

  //Agent
  const AgentDashBoard = async () => {
    try {
      await axios
        .post(
          BaseUrl + "/dashboard/taskCountByAgentId",
          {
            agent_id: LoggedInAgent.id,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          if (res.data.status) {
            setDashboardcountagent(res.data);
          } else {
            setDashboardcountagent([]);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } catch (error) { }
  };
  //Supervisor
  const SupervisorDashBoard = async () => {
    await axios
      .post(
        BaseUrl + "/dashboard/dashboardCount",
        { agent_id: LoggedInAgent.agent_id },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setDashboardcount(res.data);
        } else {
          setDashboardcount([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  var seconds = dashboardcountagent.TotalBreakTime;
  var duration = moment.duration(seconds, "seconds");
  var dashboardcountagentTotalBreakTime = moment
    .utc(duration.asMilliseconds())
    .format("HH:mm:ss");
  var seconds = dashboardcountagent.TotalActiveTime;
  var duration = moment.duration(seconds, "seconds");
  var dashboardcountagentTotalActiveTime = moment
    .utc(duration.asMilliseconds())
    .format("HH:mm:ss");

  const openOngoingInteractionApi = (agentID) => {
    setloader(true);
    let body = {
      agentId: agentID,
      offset: page == 1 ? 0 : (page - 1) * 5,
      limit: 5,
    };
    axios
      .post(BaseUrl + "/users/agentActiveChat", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.status) {
          setOngoingInteractionList(res.data.data);
          setPagination(res.data.count);
          setloader(false);
        } else {
          setOngoingInteractionList([]);
          setPagination(0);
          setloader(false);
        }
      })

      .catch((error) => {
        setOngoingInteractionList([]);
        setPagination(0);
        setloader(false);
      });
  };

  const openOngoingInteractionDialogBox = (value) => {
    setOngoingInteraction(true);
  };

  const InteractionhandleChange = (event, value) => {
    setpage(value);
  };

  const LogoutAesLiteAgent = (item) => {
    if (props.voicePlatForm == "AES") {
      const AgentLogoutStatus = {
        Event: "AgentState",
        Extension: item.agent_id.CTIagentUsername,
        Agentname: item.agent_id.CTIagentLoginTerminalId,
        AgentPassword: JSON.parse(localStorage.getItem("AvayaPassword")),
        AgentReason: "Log Out",
        AgentWorkmode: "Manual In",
        AcdGroup: "681",
      };
      WebSocket.send(JSON.stringify(AgentLogoutStatus));
    }
  };
  const UnRegisterExten = (item) => {
    if (props.voicePlatForm == "AES") {
      const RegDetails = {
        Event: "UnSubScribe",
        Extension: item.agent_id.CTIagentUsername,
      };
      WebSocket.send(JSON.stringify(RegDetails));
    }
  };

  const LogoutAgent = async (userid) => {
    if (!userid) return;
    await axios
      .post(
        BaseUrl + `/users/logout/${userid}`,
        {
          type: "forcelogout",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          toast.success(res.data.message, toaststyle);
          SupervisorTeamActivityList();
        } else {
          toast.error(res.data.message, toaststyle);
          SupervisorTeamActivityList();
        }
      })
      .catch((err) => {
        console.log("LogoutAgent", err);
      });
  };

  const statusList = async () => {
    await axios
      .post(
        BaseUrl + "/userstatus/userstatuslist",
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setUserstatus(res.data.data);
        } else {
          setUserstatus([]);
        }
      })
      .catch((err) => { });
  };

  const UpdateAgentStatus = async (value, agentId, index) => {
    await axios
      .post(
        BaseUrl + "/users/updateAgentStatus/",
        {
          status: value,
          userId: agentId.user_id,
          type: "statuschange",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        SupervisorTeamActivityList();
        handleClose(index);
      })
      .catch((err) => {
        console.log("UpdateAgentStatus", err);
      });
  };

  const QueueCount = async () => {
    await axios
      .post(
        PowerBiurl + "v1/purple/getqueuecount",
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setTotalqueueCount(res.data.totalCallsWaiting);
        } else {
          setTotalqueueCount("");
        }
      })
      .catch((err) => {
        setTotalqueueCount("");
      });
  };

  useEffect(() => {
    if (LoggedInAgent.role == "Agent") {
      AgentDashBoard();
    } else {
      QueueCount();
      SupervisorDashBoard();
      SupervisorTeamActivityList();
      statusList();
    }
  }, []);

  let intervalId;
  useEffect(() => {
    if (!intervalId) {
      intervalId = setInterval(() => {
        if (LoggedInAgent.role == "Agent") {
          AgentDashBoard();
        } else {
          QueueCount();
          SupervisorDashBoard();
          //SupervisorTeamActivityList();
        }
      }, 20000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };
  }, []);
   let intervalIds;
  useEffect(() => {
    if (!intervalIds) {
      intervalIds = setInterval(() => {
     
          SupervisorTeamActivityList();
        
      }, 10000);
    }

    return () => {
      if (intervalIds) {
        clearInterval(intervalIds);
        intervalIds = null;
      }
    };
  }, []);
  return (
    <>
      {LoggedInAgent.role == "Supervisor" ? (
        <StyledPaper elevation={0}>
          <Grid container spacing={2} direction={"column"}>
            {showAllUserList && (
              <Grid item xs={12} md={12} sm={12}>
                <Grid container spacing={1} direction={"row"}>
                  {[
                    { item: 0, title: "Agents - LoggedIn" },
                    { item: 1, title: "Agents - Active" },
                    { item: 2, title: "Agents - Offline" },
                    { item: 3, title: "Agents Not Ready" },
                    //  { item: 6, title: "Longest Wait - Digital" },
                  ].map((item) => (
                    <Grid item xs={2} md={3} sm={4} key={item.item}>
                      <div className="center">
                        <div className="design">
                          <Box
                            sx={{
                              width: "80%",
                              position: "absolute",
                              top: "20px",
                              left: "20px",
                            }}
                          >
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 600,
                                color: "#FFFF",
                                fontSize: "16px",
                                fontWeight: 800,
                                textShadow: "1px 1px 2px rgb(0 0 0 / 49%)",
                              }}
                            >
                              {item.title}
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              sx={{
                                fontWeight: 600,
                                textShadow: "1px 1px 2px rgb(0 0 0 / 41%)",
                              }}
                              className="d-flex align-items-center"
                            >
                              <FaClock className="me-2" />
                              {(() => {
                                switch (item.title) {
                                  case "Agents - LoggedIn":
                                    return (
                                      <>
                                        {dashboardcount.AgentLoggedIn == null ||
                                          dashboardcount.AgentLoggedIn ==
                                          undefined
                                          ? 0
                                          : dashboardcount.AgentLoggedIn}
                                      </>
                                    );
                                  case "Agents - Active":
                                    return (
                                      <>
                                        {dashboardcount.AgentActive == null ||
                                          dashboardcount.AgentActive == undefined
                                          ? 0
                                          : dashboardcount.AgentActive}
                                      </>
                                    );
                                  case "Agents - Offline":
                                    return (
                                      <>
                                        {dashboardcount.AgentOffline == null ||
                                          dashboardcount.AgentOffline == null
                                          ? 0
                                          : dashboardcount.AgentOffline}
                                      </>
                                    );
                                  case "Agents Not Ready":
                                    return (
                                      <>
                                        {" "}
                                        {dashboardcount.AgentNotReady == null ||
                                          dashboardcount.AgentNotReady ==
                                          undefined
                                          ? 0
                                          : dashboardcount.AgentNotReady}
                                      </>
                                    );
                                  // case "Longest Wait - Digital":
                                  //   return (
                                  //     <>
                                  //       {convertSecondsToTime(
                                  //         dashboardcount.longwait
                                  //       )}
                                  //     </>
                                  //   );
                                  default:
                                    return "";
                                }
                              })()}
                            </Typography>
                          </Box>

                          <div className="circle-1 center color-border">
                            <div className="circle-2 center color-border">
                              <div className="circle-3 center color-border">
                                <div className="circle-4 center color-border">
                                  <div className="circle-5">
                                    <img
                                      src={(() => {
                                        switch (item.title) {
                                          case "Agents - LoggedIn":
                                            return LoggedInAgents;
                                          case "Agents - Active":
                                            return AgentActive;
                                          case "Agents - Offline":
                                            return agentOffline;
                                          case "Agents Not Ready":
                                            return AgentNotReady;
                                          // case "Longest Wait - Digital":
                                          //   return LongestWait;
                                          default:
                                            return "";
                                        }
                                      })()}
                                      className="dashboard-icons"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Grid>
                  ))}
                  {permission.map((module) => {
                    if (module.moduleName === "DASHBOARD") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "LONGEST_WAIT_DIGITAL" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Grid item xs={2} md={3} sm={4}>
                            <div className="center">
                              <div className="design">
                                <Box
                                  sx={{
                                    width: "80%",
                                    position: "absolute",
                                    top: "20px",
                                    left: "20px",
                                  }}
                                >
                                  <Typography
                                    variant="h6"
                                    sx={{
                                      fontWeight: 600,
                                      color: "#FFFF",
                                      fontSize: "16px",
                                      fontWeight: 800,
                                      textShadow:
                                        "1px 1px 2px rgb(0 0 0 / 49%)",
                                    }}
                                  >
                                    Longest Wait - Digital
                                  </Typography>
                                  <Typography
                                    variant="subtitle2"
                                    sx={{
                                      fontWeight: 600,
                                      textShadow:
                                        "1px 1px 2px rgb(0 0 0 / 41%)",
                                    }}
                                    className="d-flex align-items-center"
                                  >
                                    <FaBusinessTime className="me-2" />
                                    {convertSecondsToTime(
                                      dashboardcount.longwait
                                    )}
                                  </Typography>
                                </Box>

                                <div className="circle-1 center color-border">
                                  <div className="circle-2 center color-border">
                                    <div className="circle-3 center color-border">
                                      <div className="circle-4 center color-border">
                                        <div className="circle-5">
                                          <img
                                            src={LongestWait}
                                            className="dashboard-icons"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Grid>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {permission.map((module) => {
                    if (module.moduleName === "DASHBOARD") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "ABANDONED_COUNT" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Grid item xs={2} md={3} sm={4}>
                            <div className="center">
                              <div className="design">
                                <Box
                                  sx={{
                                    width: "80%",
                                    position: "absolute",
                                    top: "20px",
                                    left: "20px",
                                  }}
                                >
                                  <Typography
                                    variant="h6"
                                    sx={{
                                      fontWeight: 600,
                                      color: "#FFFF",
                                      fontSize: "16px",
                                      fontWeight: 800,
                                      textShadow:
                                        "1px 1px 2px rgb(0 0 0 / 49%)",
                                    }}
                                  >
                                    Agent Abandoned
                                  </Typography>
                                  <Typography
                                    variant="subtitle2"
                                    sx={{
                                      fontWeight: 600,
                                      textShadow:
                                        "1px 1px 2px rgb(0 0 0 / 41%)",
                                    }}
                                    className="d-flex align-items-center"
                                  >
                                    <FaClock className="me-2" />
                                    {dashboardcount.abadoned_count == null ||
                                      dashboardcount.abadoned_count == null
                                      ? 0
                                      : dashboardcount.abadoned_count}
                                  </Typography>
                                </Box>

                                <div className="circle-1 center color-border">
                                  <div className="circle-2 center color-border">
                                    <div className="circle-3 center color-border">
                                      <div className="circle-4 center color-border">
                                        <div className="circle-5">
                                          <img
                                            src={Abandoned}
                                            className="dashboard-icons"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Grid>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {permission.map((module) => {
                    if (module.moduleName === "DASHBOARD") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "SLA_DIGITAL" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Grid item xs={2} md={3} sm={4}>
                            <div className="center">
                              <div className="design">
                                <Box
                                  sx={{
                                    width: "80%",
                                    position: "absolute",
                                    top: "20px",
                                    left: "20px",
                                  }}
                                >
                                  <Typography
                                    variant="h6"
                                    sx={{
                                      fontWeight: 600,
                                      color: "#FFFF",
                                      fontSize: "16px",
                                      fontWeight: 800,
                                      textShadow:
                                        "1px 1px 2px rgb(0 0 0 / 49%)",
                                    }}
                                  >
                                    SLA - Digital
                                  </Typography>
                                  <Typography
                                    variant="subtitle2"
                                    sx={{
                                      fontWeight: 600,
                                      textShadow:
                                        "1px 1px 2px rgb(0 0 0 / 41%)",
                                    }}
                                    className="d-flex align-items-center"
                                  >
                                    <FaClock className="me-2" />
                                    {dashboardcount.slacount == null ||
                                      dashboardcount.slacount === 0
                                      ? "0%"
                                      : dashboardcount.slacount + "%"}
                                  </Typography>
                                </Box>

                                <div className="circle-1 center color-border">
                                  <div className="circle-2 center color-border">
                                    <div className="circle-3 center color-border">
                                      <div className="circle-4 center color-border">
                                        <div className="circle-5">
                                          <img
                                            src={SLADigital}
                                            className="dashboard-icons"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Grid>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {permission.map((module) => {
                    if (module.moduleName === "DASHBOARD") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "QUEUED_COUNT_DIGITAL" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Grid item xs={2} md={3} sm={4}>
                            <div className="center">
                              <div className="design">
                                <Box
                                  sx={{
                                    width: "80%",
                                    position: "absolute",
                                    top: "20px",
                                    left: "20px",
                                  }}
                                >
                                  <Typography
                                    variant="h6"
                                    sx={{
                                      fontWeight: 600,
                                      color: "#FFFF",
                                      fontSize: "16px",
                                      fontWeight: 800,
                                      textShadow:
                                        "1px 1px 2px rgb(0 0 0 / 49%)",
                                    }}
                                  >
                                    Queued Count - Digital
                                  </Typography>
                                  <Typography
                                    variant="subtitle2"
                                    sx={{
                                      fontWeight: 600,
                                      textShadow:
                                        "1px 1px 2px rgb(0 0 0 / 41%)",
                                    }}
                                    className="d-flex align-items-center"
                                  >
                                    <FaClock className="me-2" />
                                    {dashboardcount.QueuedChat == null ||
                                      dashboardcount.QueuedChat == undefined
                                      ? 0
                                      : dashboardcount.QueuedChat}
                                  </Typography>
                                </Box>

                                <div className="circle-1 center color-border">
                                  <div className="circle-2 center color-border">
                                    <div className="circle-3 center color-border">
                                      <div className="circle-4 center color-border">
                                        <div className="circle-5">
                                          <img
                                            src={queueCount}
                                            className="dashboard-icons"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Grid>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {permission.map((module) => {
                    if (module.moduleName === "DASHBOARD") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "OFFERED_COUNT" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Grid item xs={2} md={3} sm={4}>
                            <div className="center">
                              <div className="design">
                                <Box
                                  sx={{
                                    width: "80%",
                                    position: "absolute",
                                    top: "20px",
                                    left: "20px",
                                  }}
                                >
                                  <Typography
                                    variant="h6"
                                    sx={{
                                      fontWeight: 600,
                                      color: "#FFFF",
                                      fontSize: "16px",
                                      fontWeight: 800,
                                      textShadow:
                                        "1px 1px 2px rgb(0 0 0 / 49%)",
                                    }}
                                  >
                                    Total Count
                                  </Typography>
                                  <Typography
                                    variant="subtitle2"
                                    sx={{
                                      fontWeight: 600,
                                      textShadow:
                                        "1px 1px 2px rgb(0 0 0 / 41%)",
                                    }}
                                    className="d-flex align-items-center"
                                  >
                                    <FaClock className="me-2" />
                                    {dashboardcount.totalPresentedCount ==
                                      null ||
                                      dashboardcount.totalPresentedCount ==
                                      undefined
                                      ? 0
                                      : dashboardcount.totalPresentedCount}
                                  </Typography>
                                </Box>

                                <div className="circle-1 center color-border">
                                  <div className="circle-2 center color-border">
                                    <div className="circle-3 center color-border">
                                      <div className="circle-4 center color-border">
                                        <div className="circle-5">
                                          <img
                                            src={TotalActiveTime}
                                            className="dashboard-icons"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Grid>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {permission.map((module) => {
                    if (module.moduleName === "DASHBOARD") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "ANSWERED_COUNT" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Grid item xs={2} md={3} sm={4}>
                            <div className="center">
                              <div className="design">
                                <Box
                                  sx={{
                                    width: "80%",
                                    position: "absolute",
                                    top: "20px",
                                    left: "20px",
                                  }}
                                >
                                  <Typography
                                    variant="h6"
                                    sx={{
                                      fontWeight: 600,
                                      color: "#FFFF",
                                      fontSize: "16px",
                                      fontWeight: 800,
                                      textShadow:
                                        "1px 1px 2px rgb(0 0 0 / 49%)",
                                    }}
                                  >
                                    Total Answered
                                  </Typography>
                                  <Typography
                                    variant="subtitle2"
                                    sx={{
                                      fontWeight: 600,
                                      textShadow:
                                        "1px 1px 2px rgb(0 0 0 / 41%)",
                                    }}
                                    className="d-flex align-items-center"
                                  >
                                    <FaClock className="me-2" />
                                    {dashboardcount.totalAnsweredCount ==
                                      null ||
                                      dashboardcount.totalAnsweredCount ==
                                      undefined
                                      ? 0
                                      : dashboardcount.totalAnsweredCount}
                                  </Typography>
                                </Box>

                                <div className="circle-1 center color-border">
                                  <div className="circle-2 center color-border">
                                    <div className="circle-3 center color-border">
                                      <div className="circle-4 center color-border">
                                        <div className="circle-5">
                                          <img
                                            src={AgentActive}
                                            className="dashboard-icons"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Grid>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {permission.map((module) => {
                    if (module.moduleName === "DASHBOARD") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "QUEUE_COUNT" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Grid item xs={2} md={3} sm={4}>
                            <div className="center">
                              <div className="design">
                                <Box
                                  sx={{
                                    width: "80%",
                                    position: "absolute",
                                    top: "20px",
                                    left: "20px",
                                  }}
                                >
                                  <Typography
                                    variant="h6"
                                    sx={{
                                      fontWeight: 600,
                                      color: "#FFFF",
                                      fontSize: "16px",
                                      fontWeight: 800,
                                      textShadow:
                                        "1px 1px 2px rgb(0 0 0 / 49%)",
                                    }}
                                  >
                                    Queued Count
                                  </Typography>
                                  <Typography
                                    variant="subtitle2"
                                    sx={{
                                      fontWeight: 600,
                                      textShadow:
                                        "1px 1px 2px rgb(0 0 0 / 41%)",
                                    }}
                                    className="d-flex align-items-center"
                                  >
                                    <FaClock className="me-2" />
                                    {TotalqueueCount}
                                  </Typography>
                                </Box>

                                <div className="circle-1 center color-border">
                                  <div className="circle-2 center color-border">
                                    <div className="circle-3 center color-border">
                                      <div className="circle-4 center color-border">
                                        <div className="circle-5">
                                          <img
                                            src={queueCount}
                                            className="dashboard-icons"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Grid>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                </Grid>
              </Grid>
            )}
            <Grid item xs={12} md={12} sm={12}>
              <div
                className="card-dash card"
                style={{ height: showAllUserList ? "54vh" : "84vh" }}
              >
                <div className="card-header d-flex align-items-center justify-content-between">
                  <Typography variant="h5" sx={{ fontWeight: 600 }}>
                    Team Activity
                  </Typography>
                  <IconButton
                    size="small"
                    aria-label="delete"
                    onClick={() => {
                      setshowAllUserList(!showAllUserList);
                    }}
                  >
                    {showAllUserList ? <ArrowsOut /> : <ArrowsIn />}
                  </IconButton>
                </div>
                <div className="card-body pt-0">
                  <TableContainer sx={{ height: "100%", width: "100%" }}>
                    <Table stickyHeader aria-label="sticky table" size="small">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell align="">Agent Name</StyledTableCell>
                          <StyledTableCell align="center">
                            Status
                          </StyledTableCell>

                          {permission.map((module) => {
                            if (module.moduleName === "DASHBOARD") {
                              const value = module.screen.find(
                                (item) =>
                                  item.screenId === "AGENT_IN_STATUS" &&
                                  item.read &&
                                  item.write
                              );

                              if (value) {
                                return (
                                  <StyledTableCell align="center">
                                    Agent In Status
                                  </StyledTableCell>
                                );
                              } else {
                                return <></>;
                              }
                            }
                          })}

                          <StyledTableCell align="center">
                            Ongoing Interaction
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            Presented
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            Answered
                          </StyledTableCell>
                          {permission.map((module) => {
                            if (module.moduleName === "DASHBOARD") {
                              const value = module.screen.find(
                                (item) =>
                                  item.screenId === "ABANDONED_COUNT" &&
                                  item.read &&
                                  item.write
                              );

                              if (value) {
                                return (
                                  <StyledTableCell align="center">
                                    Abandoned
                                  </StyledTableCell>
                                );
                              } else {
                                return <></>;
                              }
                            }
                          })}
                          {permission.map((module) => {
                            if (module.moduleName === "DASHBOARD") {
                              const value = module.screen.find(
                                (item) =>
                                  item.screenId === "TRANSFER_COUNT" &&
                                  item.read &&
                                  item.write
                              );

                              if (value) {
                                return (
                                  <StyledTableCell align="center">
                                    Transferred
                                  </StyledTableCell>
                                );
                              } else {
                                return <></>;
                              }
                            }
                          })}
                          {permission.map((module) => {
                            if (module.moduleName === "DASHBOARD") {
                              const value = module.screen.find(
                                (item) =>
                                  item.screenId === "DIALED_OUTBOUND" &&
                                  item.read &&
                                  item.write
                              );

                              if (value) {
                                return (
                                  <StyledTableCell align="center">
                                    Dialed Outbound
                                  </StyledTableCell>
                                );
                              } else {
                                return <></>;
                              }
                            }
                          })}
                          {permission.map((module) => {
                            if (module.moduleName === "DASHBOARD") {
                              const value = module.screen.find(
                                (item) =>
                                  item.screenId === "FORCE_LOGOUT" &&
                                  item.read &&
                                  item.write
                              );

                              if (value) {
                                return (
                                  <StyledTableCell align="center">
                                    Logout
                                  </StyledTableCell>
                                );
                              } else {
                                return (
                                  <StyledTableCell align="center">
                                    Logout
                                  </StyledTableCell>
                                );
                              }
                            }
                          })}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {teamactivitydashboardcount.length > 0 ? (
                          teamactivitydashboardcount.map((item, index) => (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={index}
                            >
                              <StyledTableCell2>
                                {item.agent_id == null ||
                                  item.agent_id == undefined ||
                                  item.agent_id == ""
                                  ? "--"
                                  : item.agent_id.username}
                              </StyledTableCell2>

                              <StyledTableCell2 align="center">
                                <Chip
                                  aria-describedby={id(index)}
                                  onClick={(event) => {
                                    if (
                                      item.agent_id.id !=
                                      LoggedInAgent.agent_id ||
                                      item.agent_id.agent_status_real ===
                                      "InCall"
                                    ) {
                                      handleClick(event, index);
                                    }
                                  }}
                                  size="small"
                                  label={item.agent_id.agent_status_real}
                                  color={
                                    item.agent_id.agent_status_real ==
                                      "Available" ||
                                      item.agent_id.agent_status_real == "Ready"
                                      ? "success"
                                      : item.agent_id.agent_status_real ==
                                        "Connected"
                                        ? "default"
                                        : "error"
                                  }
                                  sx={{
                                    height: "15px",
                                    width: "90px",
                                    "& .MuiChip-label": {
                                      fontSize: "10px",
                                    },
                                  }}
                                />
                              </StyledTableCell2>

                              {permission.map((module) => {
                                if (module.moduleName === "DASHBOARD") {
                                  const value = module.screen.find(
                                    (item) =>
                                      item.screenId === "AGENT_IN_STATUS" &&
                                      item.read &&
                                      item.write
                                  );

                                  if (value) {
                                    return (
                                      <StyledTableCell2 align="center">
                                        {item.agent_id.lastactive_time
                                          ? calculateDuration(
                                            item.agent_id.lastactive_time
                                          )
                                          : "N/A"}
                                      </StyledTableCell2>
                                    );
                                  } else {
                                    return <></>;
                                  }
                                }
                              })}
                              <StyledTableCell2 align="center">
                                <IconButton
                                  disabled={item.total_active ? false : true}
                                  onClick={() => {
                                    if (
                                      item.agent_id.id != LoggedInAgent.agent_id
                                    ) {
                                      openOngoingInteractionApi(
                                        item.agent_id.id
                                      );
                                      openOngoingInteractionDialogBox();
                                    }
                                  }}
                                >
                                  <Badge
                                    badgeContent={item.total_active}
                                    color="warning"
                                    sx={{ zIndex: "0" }}
                                  >
                                    <QuickreplyIcon color="primary" />
                                  </Badge>
                                </IconButton>
                              </StyledTableCell2>
                              <StyledTableCell2 align="center">
                                <Badge
                                  badgeContent={item.presented_count}
                                  color="warning"
                                  sx={{ zIndex: "0" }}
                                >
                                  <ForumIcon color="primary" />
                                </Badge>
                              </StyledTableCell2>
                              <StyledTableCell2 align="center">
                                <Badge
                                  badgeContent={item.answered_count}
                                  color="warning"
                                  sx={{ zIndex: "0" }}
                                >
                                  <PermPhoneMsgIcon color="primary" />
                                </Badge>
                              </StyledTableCell2>
                              {permission.map((module) => {
                                if (module.moduleName === "DASHBOARD") {
                                  const value = module.screen.find(
                                    (item) =>
                                      item.screenId === "ABANDONED_COUNT" &&
                                      item.read &&
                                      item.write
                                  );

                                  if (value) {
                                    return (
                                      <StyledTableCell2 align="center">
                                        <Badge
                                          badgeContent={item.abadoned_count}
                                          color="warning"
                                          sx={{ zIndex: "0" }}
                                        >
                                          <OutboundIcon color="primary" />
                                        </Badge>
                                      </StyledTableCell2>
                                    );
                                  } else {
                                    return <></>;
                                  }
                                }
                              })}
                              {permission.map((module) => {
                                if (module.moduleName === "DASHBOARD") {
                                  const value = module.screen.find(
                                    (item) =>
                                      item.screenId === "TRANSFER_COUNT" &&
                                      item.read &&
                                      item.write
                                  );

                                  if (value) {
                                    return (
                                      <StyledTableCell2 align="center">
                                        <Badge
                                          badgeContent={
                                            item.total_transferred_out
                                          }
                                          color="warning"
                                          sx={{ zIndex: "0" }}
                                        >
                                          <SyncAltIcon color="primary" />
                                        </Badge>
                                      </StyledTableCell2>
                                    );
                                  } else {
                                    return <></>;
                                  }
                                }
                              })}
                              {permission.map((module) => {
                                if (module.moduleName === "DASHBOARD") {
                                  const value = module.screen.find(
                                    (item) =>
                                      item.screenId === "DIALED_OUTBOUND" &&
                                      item.read &&
                                      item.write
                                  );

                                  if (value) {
                                    return (
                                      <StyledTableCell2 align="center">
                                        <Badge
                                          badgeContent={item.outbound_count}
                                          color="warning"
                                          sx={{ zIndex: "0" }}
                                        >
                                          <CallMadeIcon color="primary" />
                                        </Badge>
                                      </StyledTableCell2>
                                    );
                                  } else {
                                    return <></>;
                                  }
                                }
                              })}
                              {permission.map((module) => {
                                if (module.moduleName === "DASHBOARD") {
                                  const value = module.screen.find(
                                    (item) =>
                                      item.screenId === "FORCE_LOGOUT" &&
                                      item.read &&
                                      item.write
                                  );

                                  if (value) {
                                    return (
                                      <StyledTableCell2 align="center">
                                        <Tooltip
                                          title="LogOut Agent"
                                          arrow
                                          placement="top"
                                        >
                                          <IconButton
                                            disabled={
                                              item.agent_id
                                                .agent_status_real ===
                                              "Is LoggedOut" ||
                                              item.agent_id
                                                .agent_status_real ===
                                              "InCall" ||
                                              item.agent_id.id ==
                                              LoggedInAgent.agent_id ||
                                              item.total_active !== 0
                                            }
                                            onClick={() => {
                                              LogoutAesLiteAgent(item);
                                              UnRegisterExten(item);
                                              setTimeout(() => {
                                                LogoutAgent(
                                                  item.agent_id.user_id
                                                );
                                              }, 2000);
                                            }}
                                          >
                                            <SignOut
                                              size={15}
                                              weight="bold"
                                              color="#FC3165"
                                            />
                                          </IconButton>
                                        </Tooltip>
                                      </StyledTableCell2>
                                    );
                                  } else {
                                    return (
                                      <StyledTableCell2 align="center">
                                        <Tooltip
                                          title="Contact Admin"
                                          arrow
                                          placement="top"
                                        >
                                          <IconButton>
                                            <SignOut
                                              size={15}
                                              weight="bold"
                                              color="#FC3165"
                                            />
                                          </IconButton>
                                        </Tooltip>
                                      </StyledTableCell2>
                                    );
                                  }
                                }
                              })}
                              <Popover
                                id={id(index)}
                                open={openPopover(index)}
                                anchorEl={anchorEl[index]}
                                onClose={() => handleClose(index)}
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "right",
                                }}
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "left",
                                }}
                              >
                                <List
                                  sx={{
                                    width: "100%",
                                    maxWidth: 360,
                                    bgcolor: "background.paper",
                                  }}
                                >
                                  <ListItemButton
                                    sx={{
                                      "&.MuiListItemButton-root": {
                                        paddingTop: "none",
                                        paddingBottom: "none",
                                      },
                                    }}
                                    onClick={() => {
                                      UpdateAgentStatus(
                                        "Ready",
                                        item.agent_id,
                                        index
                                      );
                                    }}
                                  >
                                    <ListItemText
                                      primary="Ready"
                                      sx={{
                                        "&.MuiListItemButton-root": {
                                          paddingTop: "none",
                                          paddingBottom: "none",
                                        },
                                      }}
                                    />
                                  </ListItemButton>

                                  <ListItemButton>
                                    <Stack
                                      direction={"row"}
                                      justifyContent={"space-between"}
                                      alignItems={"center"}
                                      spacing={3}
                                    >
                                      <ListItemText
                                        primary="Not Ready"
                                        onClick={() => {
                                          UpdateAgentStatus(
                                            "Not Ready",
                                            item.agent_id,
                                            index
                                          );
                                        }}
                                      />

                                      {open2 ? (
                                        <IconButton
                                          onClick={() => {
                                            handleClick2();
                                          }}
                                        >
                                          <ExpandLess />
                                        </IconButton>
                                      ) : (
                                        <IconButton
                                          onClick={() => {
                                            handleClick2();
                                          }}
                                        >
                                          <ExpandMore />
                                        </IconButton>
                                      )}
                                    </Stack>
                                  </ListItemButton>

                                  {open2 && (
                                    <>
                                      {userstatus.map((status, subIndex) => (
                                        <ListItemButton
                                          sx={{ pl: 4 }}
                                          key={subIndex}
                                          onClick={() => {
                                            UpdateAgentStatus(
                                              status.statusName,
                                              item.agent_id,
                                              index
                                            );
                                          }}
                                        >
                                          <ListItemText
                                            primary={status.statusName}
                                          />
                                        </ListItemButton>
                                      ))}
                                    </>
                                  )}
                                </List>
                              </Popover>
                            </TableRow>
                          ))
                        ) : (
                          // Data unavailable start
                          <Stack
                            sx={{
                              position: "absolute",
                              width: "100%",
                              height: "calc(100vh - 14rem)",
                            }}
                            justifyContent="center"
                            alignContent="center"
                          >
                            <Stack
                              className="text-muted"
                              direction="column"
                              justifyContent="center"
                              alignContent="center"
                            >
                              <span className="mx-auto">
                                <img
                                  src={Nodata}
                                  alt="pic"
                                  style={{ width: "11rem", userSelect: "none" }}
                                />
                              </span>
                              <span className="mx-auto">
                                <h6
                                  className="text-muted mt-3"
                                  style={{ fontSize: "13px" }}
                                >
                                  Data unavailable
                                </h6>
                              </span>
                            </Stack>
                          </Stack>
                          // Data unavailable end
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </Grid>
          </Grid>

          {OngoingInteraction && (
            <Dialog
              open={OngoingInteraction}
              keepMounted
              onClose={() => {
                setOngoingInteraction(false);
              }}
              aria-describedby="alert-dialog-slide-description"
              sx={{
                "& .MuiPaper-root": {
                  padding: 1,
                  top: -50,
                },
                backgroundColor: "rgb(0 0 0 / 15%)",
              }}
            >
              <DialogTitle
                variant="subtitle2"
                sx={{ fontSize: "16px", fontWeight: 600 }}
              >
                ONGOING INTERACTION
              </DialogTitle>
              <DialogContent>
                <TableContainer sx={{ height: "100%", width: "100%" }}>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {[
                          "Customer Name",
                          "Arival Time",
                          "Channel",
                          "Observe",
                        ].map((headers, index) => (
                          <StyledTableCell align="center" key={index}>
                            {headers}
                          </StyledTableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {OngoingInteractionList.length > 0 ? (
                        OngoingInteractionList.map((item, index) => (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={index}
                          >
                            <StyledTableCell3 align="center">
                              {item.unique_id.username == ""
                                ? item.unique_id.phonenumber
                                : item.unique_id.username}
                            </StyledTableCell3>

                            <StyledTableCell3 align="center">
                              {moment(item.arrival_at).format("LT L")}
                            </StyledTableCell3>

                            <StyledTableCell3 align="center">
                              {item.channel == "webchat" ? (
                                <ChatsCircle size={18} weight="bold" />
                              ) : item.channel == "from_whatsapp" ? (
                                <WhatsappLogo size={18} weight="bold" />
                              ) : item.channel == "from_facebook" ? (
                                <FacebookLogo size={18} weight="bold" />
                              ) : item.channel == "from_twitter" ? (
                                <TwitterLogo size={18} weight="bold" />
                              ) : item.channel == "from_teams" ? (
                                <ChatsCircle size={18} weight="bold" />
                              ) : item.channel == "videochat" ? (
                                <VideoCamera size={18} weight="bold" />
                              ) : item.channel == "voice" ? (
                                <Phone size={18} weight="bold" />
                              ) : item.channel == "from_purple" ? (
                                <Robot size={18} weight="bold" />
                              ) : (
                                <Envelope size={18} weight="bold" />
                              )}
                            </StyledTableCell3>
                            <StyledTableCell3 align="center">
                              <div
                                className="d-flex"
                                style={{ justifyContent: "space-evenly" }}
                              >
                                {permission.map((module) => {
                                  if (module.moduleName === "DASHBOARD") {
                                    const value = module.screen.find(
                                      (item) =>
                                        (item.screenId === "OBSERVE_VOICE" && item.read && item.write) ||
                                        (item.screenId === "OBSERVE_CHAT" && item.read && item.write)
                                    );
                                    if (value) {
                                      return (
                                        <Tooltip
                                          title={"Observe"}
                                          arrow
                                          placement="top"
                                        >
                                          <IconButton
                                            onClick={() => {
                                              if (item.direction == "Outbound" && item.channel == "voice") {
                                                outboundOberver(item);
                                              } else {
                                                SupervisorObserver(item);
                                              }
                                            }}
                                            disabled={!value || !value.read && !value.write}
                                          >
                                            <Eye size={18} weight="bold" />
                                          </IconButton>
                                        </Tooltip>
                                      );
                                    } else {
                                      return (
                                        <IconButton disabled={true}>
                                          <Eye size={18} weight="bold" />
                                        </IconButton>
                                      );
                                    }
                                  }
                                })}
                              </div>
                            </StyledTableCell3>
                          </TableRow>
                        ))
                      ) : (
                        <Stack
                          sx={{ position: "absolute", top: "50%", left: "50%" }}
                        >
                          {loader ? (
                            <>
                              <Spinner animation="border" variant="primary" />
                              <span
                                className="position-relative mt-2"
                                style={{ left: "-10px" }}
                              >
                                Loading...
                              </span>
                            </>
                          ) : (
                            <>
                              <TiWarningOutline
                                size={30}
                                className="mx-auto text-muted"
                              />
                              <span className="fw-bold text-muted">
                                No Data Found
                              </span>
                            </>
                          )}
                        </Stack>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Box
                  style={{
                    height: "10%",
                    background: "#e9e9e9",
                    padding: "10px 10px",
                    borderRadius: "10px",
                  }}
                >
                  <Stack
                    sx={{ width: "100%", height: "100%" }}
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                  >
                    <Typography variant="caption">
                      Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                      {Math.min(page * 10, pagination)} of {pagination} entries
                    </Typography>
                    <Pagination
                      variant="outlined"
                      count={Math.ceil(pagination / 5)}
                      page={page}
                      shape="rounded"
                      color="primary"
                      size="small"
                      style={{ float: "right" }}
                      onChange={InteractionhandleChange}
                    />
                  </Stack>
                </Box>
              </DialogContent>
            </Dialog>
          )}
        </StyledPaper>
      ) : (
        <StyledPaper2 elevation={0} className="overflow-hidden">
          <Grid container spacing={2} direction={"column"}>
            <Grid item xs={12} md={12} sm={12}>
              <Grid container spacing={1} direction={"row"}>
                {[
                  { item: 0, title: "Total Active Time" },
                  { item: 1, title: "Total Break Time" },
                ].map((item) => (
                  <Grid item xs={6} md={6} sm={6} key={item.item}>
                    <div className="center">
                      <div className="design">
                        <Box
                          sx={{
                            width: "80%",
                            position: "absolute",
                            top: "15px",
                            left: "20px",
                          }}
                        >
                          <Typography
                            variant="h6"
                            sx={{
                              fontSize: "16px",
                              fontWeight: 800,
                              textShadow: "1px 1px 2px rgb(0 0 0 / 41%)",
                            }}
                          >
                            {item.title}
                          </Typography>
                          <Typography
                            variant="subtitle2"
                            sx={{
                              fontWeight: 600,
                              textShadow: "1px 1px 2px rgb(0 0 0 / 41%)",
                            }}
                            className="d-flex align-items-center"
                          >
                            <FaClock className="me-2" />
                            {item.title == "Total Active Time"
                              ? dashboardcountagentTotalActiveTime
                              : dashboardcountagentTotalBreakTime}
                          </Typography>
                        </Box>

                        <div className="circle-1 center color-border">
                          <div className="circle-2 center color-border">
                            <div className="circle-3 center color-border">
                              <div className="circle-4 center color-border">
                                <div className="circle-5">
                                  <img
                                    src={
                                      item.title == "Total Active Time"
                                        ? TotalActiveTime
                                        : TotalBreakTime
                                    }
                                    className="dashboard-icons"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Grid>
                ))}
              </Grid>
            </Grid>

            <Grid item xs={12} md={12} sm={12}>
              <Grid
                container
                spacing={2}
                direction={"row"}
                sx={{ height: "100%" }}
              >
                <Grid item xs={12} md={12} sm={12}>
                  <div className="card-dash card">
                    <div className="card-header d-flex align-items-center justify-content-between">
                      <Typography variant="h5" sx={{ fontWeight: 600 }}>
                        My Activity
                      </Typography>
                    </div>
                    <div className="card-body pt-0">
                      <TableContainer
                        sx={{ height: "100%", width: "100%" }}
                        className="CONTACT-LIST-AREA"
                      >
                        <Table stickyHeader aria-label="sticky table">
                          <TableHead>
                            <TableRow>
                              <StyledTableCell align="">
                                Agent Name
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                Status
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                Ongoing Interaction
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                Presented
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                Answered
                              </StyledTableCell>
                              {permission.map((module) => {
                                if (module.moduleName === "DASHBOARD") {
                                  const value = module.screen.find(
                                    (item) =>
                                      item.screenId === "ABANDONED_COUNT" &&
                                      item.read &&
                                      item.write
                                  );

                                  if (value) {
                                    return (
                                      <StyledTableCell align="center">
                                        Abandoned
                                      </StyledTableCell>
                                    );
                                  } else {
                                    return <></>;
                                  }
                                }
                              })}
                              {permission.map((module) => {
                                if (module.moduleName === "DASHBOARD") {
                                  const value = module.screen.find(
                                    (item) =>
                                      item.screenId === "TRANSFER_COUNT" &&
                                      item.read &&
                                      item.write
                                  );

                                  if (value) {
                                    return (
                                      <StyledTableCell align="center">
                                        Transferred
                                      </StyledTableCell>
                                    );
                                  } else {
                                    return <></>;
                                  }
                                }
                              })}
                              {permission.map((module) => {
                                if (module.moduleName === "DASHBOARD") {
                                  const value = module.screen.find(
                                    (item) =>
                                      item.screenId === "DIALED_OUTBOUND" &&
                                      item.read &&
                                      item.write
                                  );

                                  if (value) {
                                    return (
                                      <StyledTableCell align="center">
                                        Dialed Outbound
                                      </StyledTableCell>
                                    );
                                  } else {
                                    return <></>;
                                  }
                                }
                              })}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow hover role="checkbox" tabIndex={-1}>
                              <StyledTableCell2>
                                {dashboardcountagent.user == null ||
                                  dashboardcountagent.user == undefined ||
                                  dashboardcountagent.user == ""
                                  ? "--"
                                  : dashboardcountagent.user.username}
                              </StyledTableCell2>
                              <StyledTableCell2 align="center">
                                {dashboardcountagent.user == null ||
                                  dashboardcountagent.user == undefined ||
                                  dashboardcountagent.user == "" ? (
                                  "--"
                                ) : dashboardcountagent.user
                                  .agent_status_real == "Not Available" ? (
                                  <Chip
                                    size="small"
                                    label={
                                      dashboardcountagent.user.agent_status_real
                                    }
                                    color={"error"}
                                    sx={{
                                      height: "15px",
                                      width: "90px",
                                      "& .MuiChip-label": {
                                        fontSize: "10px",
                                      },
                                    }}
                                  />
                                ) : dashboardcountagent.user
                                  .agent_status_real == "Ready" ||
                                  dashboardcountagent.user.agent_status_real ==
                                  "Available" ? (
                                  <Chip
                                    size="small"
                                    label={
                                      dashboardcountagent.user.agent_status_real
                                    }
                                    color={"success"}
                                    sx={{
                                      height: "15px",
                                      width: "90px",
                                      "& .MuiChip-label": {
                                        fontSize: "10px",
                                      },
                                    }}
                                  />
                                ) : dashboardcountagent.user
                                  .agent_status_real == "Connected" ? (
                                  <Chip
                                    size="small"
                                    label={
                                      dashboardcountagent.user.agent_status_real
                                    }
                                    color={"default"}
                                    sx={{
                                      height: "15px",
                                      width: "90px",
                                      "& .MuiChip-label": {
                                        fontSize: "10px",
                                      },
                                    }}
                                  />
                                ) : (
                                  <Chip
                                    size="small"
                                    label={
                                      dashboardcountagent.user.agent_status_real
                                    }
                                    color={"error"}
                                    sx={{
                                      height: "15px",
                                      width: "90px",
                                      "& .MuiChip-label": {
                                        fontSize: "10px",
                                      },
                                    }}
                                  />
                                )}
                              </StyledTableCell2>
                              <StyledTableCell2 align="center">
                                <Badge
                                  badgeContent={
                                    dashboardcountagent
                                      ? dashboardcountagent.totalongoingcount
                                      : null
                                  }
                                  color="warning"
                                  sx={{ zIndex: "0" }}
                                >
                                  <GroupIcon color="primary" cursor="auto" />
                                </Badge>
                              </StyledTableCell2>
                              <StyledTableCell2 align="center">
                                <Badge
                                  badgeContent={
                                    dashboardcountagent
                                      ? dashboardcountagent.presentedcount
                                      : null
                                  }
                                  color="warning"
                                  sx={{ zIndex: "0" }}
                                >
                                  <ForumIcon color="primary" cursor="auto" />
                                </Badge>
                              </StyledTableCell2>
                              <StyledTableCell2 align="center">
                                <Badge
                                  badgeContent={
                                    dashboardcountagent.answered_count
                                  }
                                  color="warning"
                                  sx={{ zIndex: "0" }}
                                >
                                  <PermPhoneMsgIcon
                                    color="primary"
                                    cursor="auto"
                                  />
                                </Badge>
                              </StyledTableCell2>
                              {permission.map((module) => {
                                if (module.moduleName === "DASHBOARD") {
                                  const value = module.screen.find(
                                    (item) =>
                                      item.screenId === "ABANDONED_COUNT" &&
                                      item.read &&
                                      item.write
                                  );

                                  if (value) {
                                    return (
                                      <StyledTableCell2 align="center">
                                        <Badge
                                          badgeContent={
                                            dashboardcountagent
                                              ? dashboardcountagent.abadonedcount
                                              : null
                                          }
                                          color="warning"
                                          sx={{ zIndex: "0" }}
                                        >
                                          <OutboundIcon
                                            color="primary"
                                            cursor="auto"
                                          />
                                        </Badge>
                                      </StyledTableCell2>
                                    );
                                  } else {
                                    return <></>;
                                  }
                                }
                              })}
                              {permission.map((module) => {
                                if (module.moduleName === "DASHBOARD") {
                                  const value = module.screen.find(
                                    (item) =>
                                      item.screenId === "TRANSFER_COUNT" &&
                                      item.read &&
                                      item.write
                                  );

                                  if (value) {
                                    return (
                                      <StyledTableCell2 align="center">
                                        <Badge
                                          badgeContent={
                                            dashboardcountagent
                                              ? dashboardcountagent.TotalTransferedOut
                                              : null
                                          }
                                          color="warning"
                                          sx={{ zIndex: "0" }}
                                        >
                                          <SyncAltIcon
                                            color="primary"
                                            cursor="auto"
                                          />
                                        </Badge>
                                      </StyledTableCell2>
                                    );
                                  } else {
                                    return <></>;
                                  }
                                }
                              })}
                              {permission.map((module) => {
                                if (module.moduleName === "DASHBOARD") {
                                  const value = module.screen.find(
                                    (item) =>
                                      item.screenId === "DIALED_OUTBOUND" &&
                                      item.read &&
                                      item.write
                                  );

                                  if (value) {
                                    return (
                                      <StyledTableCell2 align="center">
                                        <Badge
                                          badgeContent={
                                            dashboardcountagent
                                              ? dashboardcountagent.outbound_count
                                              : null
                                          }
                                          color="warning"
                                          sx={{ zIndex: "0" }}
                                        >
                                          <CallMadeIcon
                                            color="primary"
                                            cursor="auto"
                                          />
                                        </Badge>
                                      </StyledTableCell2>
                                    );
                                  } else {
                                    return <></>;
                                  }
                                }
                              })}
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </StyledPaper2>
      )}
    </>
  );
};

export default connect(mapStateToProps, {
  setsidebarVal,
  endInteraction,
})(Dashboard);
